import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from './info';

const supabaseUrl = `https://${projectId}.supabase.co`;

// Create Supabase client with better error handling for refresh tokens
export const supabase = createClient(supabaseUrl, publicAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Don't throw errors on invalid refresh tokens, return null instead
    storageKey: 'axorigin-auth',
  },
});

export type User = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  created_at: string;
};

export type Website = {
  id: string;
  user_id: string;
  name: string;
  url: string;
  company_name?: string;
  created_at: string;
};
